import React from "react";
import { Button, Carousel } from "antd";
import { Alert, Images, InfiniteScrollComponent } from "../../../components";
import { useMediaQuery } from "react-responsive";
import { connect } from "react-redux";
import Card from "./Card";
import HomeHeader from "./HomeHeader";
import { loadUpcomingDraws } from "../../../redux/actions/sportTypesActions";

const slides = [
  "Home",
  "Lucky Numbers",
  "Next Draws",
  "Results",
  "How to play",
  "Home",
  "Lucky Numbers",
  "Next Draws",
  "Results",
  "How to play",
];
const IsMiddleScreenAndMobile = ({ children }) => {
  const isMiddleScreenAndMobile = useMediaQuery({ maxWidth: 1300 });
  return isMiddleScreenAndMobile ? children : null;
};
const IsDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1301 });
  return isDesktop ? children : null;
};
export class HomeCourasel extends React.Component {
  state = {
    currentSlide: 0,
    numSlides: 0,
  };
  componentDidUpdate(prevProps) {
    const { loadUpcomingDraws, match, connected } = this.props;
    if (this.props.currentFilter != prevProps.currentFilter) {
      if (this.carouselRef) this.carouselRef.goTo(0); // Go to the first slide
      if (connected) {
        if (this.props.currentFilter == 1) {
          let request = {
            Data: {
              Feed: { FeedId: Number(match.params.feed) },
              Sport: { SportId: Number(match.params.sport) },
              pageSize: 5,
              pageIndex: 0,
            },
          };
          loadUpcomingDraws(request, false);
        } else if (this.props.currentFilter == 2) {
          let request = {
            Data: {
              isTopBet: true,
              Feed: { FeedId: Number(match.params.feed) },
              Sport: { SportId: Number(match.params.sport) },
              pageSize: 5,
              pageIndex: 0,
            },
          };
          loadUpcomingDraws(request, false);
        } else if (this.props.currentFilter == 3) {
          let request = {
            Data: {
              isFavoriteTab: true,
              Feed: { FeedId: Number(match.params.feed) },
              Sport: { SportId: Number(match.params.sport) },
              pageSize: 5,
              pageIndex: 0,
            },
          };
          loadUpcomingDraws(request, false);
        }
      }
      this.setState({
        currentSlide: 0,
        numSlides: 5,
      });
      this.props.changePageIndex(0);
    }
    if (prevProps.upcomingDrawsEvents != this.props.upcomingDrawsEvents) {
      if (this.carouselRef) {
        this.setState({
          numSlides: this.carouselRef.innerSlider.state.slideCount,
        });
      }
    }
  }

  componentDidMount() {
    if (this.carouselRef) {
      this.setState({
        numSlides: this.carouselRef.innerSlider.state.slideCount,
      });
    }
  }
  onArrowClick = (direction, nextDisabled, currentFilter) => {
    // currentfilter: 1 => upcoming draws
    // currentfilter: 2 => Most Played
    // currentfilter: 3 => Favorites
    const { currentSlide, numSlides } = this.state;
    const { loadUpcomingDraws, match, connected } = this.props;
    console.log("currentSlide", currentSlide);
    console.log("numSlides", numSlides);
    console.log("nextDisabled", nextDisabled);
    switch (direction) {
      case "prev":
        this.props.changePageIndex(this.props.pageIndex - 1);
        if (connected) {
          if (currentFilter == 1) {
            let request = {
              Data: {
                Feed: { FeedId: Number(match.params.feed) },
                Sport: { SportId: Number(match.params.sport) },
                pageSize: 5,
                pageIndex: this.props.pageIndex - 1,
              },
            };
            loadUpcomingDraws(request, true);
          } else if (currentFilter == 2) {
            let request = {
              Data: {
                isTopBet: true,
                Feed: { FeedId: Number(match.params.feed) },
                Sport: { SportId: Number(match.params.sport) },
                pageSize: 5,
                pageIndex: this.props.pageIndex - 1,
              },
            };
            loadUpcomingDraws(request, true);
          } else if (currentFilter == 3) {
            let request = {
              Data: {
                isFavoriteTab: true,
                Feed: { FeedId: Number(match.params.feed) },
                Sport: { SportId: Number(match.params.sport) },
                pageSize: 5,
                pageIndex: this.props.pageIndex - 1,
              },
            };
            loadUpcomingDraws(request, true);
          }
        }

        if (currentSlide >= 5 && !nextDisabled) {
          this.carouselRef.goTo(currentSlide - 5);
        } else {
          this.carouselRef.goTo(0);
        }
        break;

      case "next":
        this.props.changePageIndex(this.props.pageIndex + 1);
        if (connected) {
          if (currentFilter == 1) {
            let request = {
              Data: {
                Feed: { FeedId: Number(match.params.feed) },
                Sport: { SportId: Number(match.params.sport) },
                pageSize: 5,
                pageIndex: this.props.pageIndex + 1,
              },
            };
            loadUpcomingDraws(request, true);
          } else if (currentFilter == 2) {
            let request = {
              Data: {
                isTopBet: true,
                Feed: { FeedId: Number(match.params.feed) },
                Sport: { SportId: Number(match.params.sport) },
                pageSize: 5,
                pageIndex: this.props.pageIndex + 1,
              },
            };
            loadUpcomingDraws(request, true);
          } else if (currentFilter == 3) {
            let request = {
              Data: {
                isFavoriteTab: true,
                Feed: { FeedId: Number(match.params.feed) },
                Sport: { SportId: Number(match.params.sport) },
                pageSize: 5,
                pageIndex: this.props.pageIndex + 1,
              },
            };
            loadUpcomingDraws(request, true);
          }
        }
        if (currentSlide + 5 < numSlides && !nextDisabled) {
          this.carouselRef.goTo(currentSlide + 5);
        } else {
          this.carouselRef.goTo(numSlides - 1);
        }
        break;
    }
  };

  render() {
    const { currentSlide, numSlides } = this.state;
    const prevDisabled = this.props.pageIndex == 0;
    const nextDisabled =
      this.props.upcomingDrawsEvents &&
      Object.values(this.props.upcomingDrawsEvents).length == 0;
    let data;
    if (
      this.props.upcomingDrawsEvents &&
      Object.values(this.props.upcomingDrawsEvents).length > 0
    ) {
      data = Object.values(this.props.upcomingDrawsEvents).slice(
        this.props.pageIndex == 0
          ? this.props.pageIndex
          : this.props.pageIndex * 5,
        this.props.pageIndex == 0 ? 5 : (this.props.pageIndex + 1) * 5
      );
    }

    if (this.props.loadingUpcomingDraws || !this.props.connected) {
      return (
        <div className="lds-parent-ring">
          <div class="lds-ring">
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      );
    }
    if (this.props.upcomingDrawsEventsError) {
      return (
        <Alert type={"error"} message={this.props.upcomingDrawsEventsError} />
      );
    }
    // eventTournament.tournamentDisplayName
    // eventDateOfMatch
    // eventCategory.categoryFlagCode
    return (
      <>
        {data ? (
          <>
            <div className="lucky-numbers-courasel">
              {data.length > 0 && (
                <>
                  <button
                    disabled={prevDisabled}
                    onClick={() =>
                      this.onArrowClick(
                        "prev",
                        nextDisabled,
                        this.props.currentFilter
                      )
                    }
                    className="nav-button prev-arrow"
                  >
                    <img src={Images.LeftArrowIcon} alt="previous-arrow" />
                  </button>
                  <button
                    disabled={nextDisabled}
                    onClick={() =>
                      this.onArrowClick(
                        "next",
                        nextDisabled,
                        this.props.currentFilter
                      )
                    }
                    className="nav-button next-arrow"
                  >
                    <img src={Images.RightArrowIcon} alt="next-arrow" />
                  </button>
                </>
              )}

              <IsDesktop>
                {" "}
                {this.props.appendNewList ? (
                  <div className="lds-parent-ring" style={{height:"354px" , alignItems:"center"}}>
                    <div class="lds-ring">
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                ) : (
                  <Carousel
                    ref={(ref) => (this.carouselRef = ref)}
                    slidesToShow={5}
                    dots={false}
                    effect="scrollx"
                    infinite={false}
                    // autoplay={true}
                    touchMove={true}
                    afterChange={(current) =>
                      this.setState({ currentSlide: current })
                    }
                  >
                    {data.map((item, idx) => {
                      return (
                        <div key={item.eventId}>
                          <Card
                            item={item}
                            enableBet={item.enableBet}
                            key={item.eventId}
                            idx={idx}
                            name={item.eventTournament.tournamentDisplayName}
                            date={item.eventDateOfMatch}
                            flagCode={item.eventCategory.categoryFlagCode}
                            eventId={item.eventId}
                            match={this.props.match}
                            history={this.props.history}
                          />
                        </div>
                      );
                    })}
                  </Carousel>
                )}
              </IsDesktop>
              <IsMiddleScreenAndMobile>
                {" "}
                <InfiniteScrollComponent
                  match={this.props.match}
                  history={this.props.history}
                  currentFilter={this.props.currentFilter}
                />
              </IsMiddleScreenAndMobile>
            </div>
          </>
        ) : null}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loadingUpcomingDraws: state.sportTypes.loadingUpcomingDraws,
    upcomingDrawsEvents: state.sportTypes.upcomingDrawsEvents,
    upcomingDrawsEventsError: state.sportTypes.upcomingDrawsEventsError,
    connected: state.signalr.luckyNumbersConnected,
    appendNewList: state.sportTypes.appendNewList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadUpcomingDraws: (item, addNewList) => {
      dispatch(loadUpcomingDraws(item, addNewList));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeCourasel);
